export default () => ({
  celular: "",
  telefono: "",
  nombre: "",
  segundoNombre: "",
  apellido: "",
  email: "",
  telefonoId: "",
});
